import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	checkIcon: { color: 'green', fontSize: '2rem' },
	exIcon: { color: 'red', fontSize: '2rem' },
	table: {
		backgroundColor: theme.palette.primary.main,
		border: '1px',
		borderStyle: 'solid',
		borderColor: theme.palette.primary.main,
		overflow: 'none',
		width: '100%',
	},
	nestedTable: {
		borderColor: theme.palette.secondary.main,
		borderWidth: '0px',
	},
	rounded: {
		borderRadius: '0.7rem',
	},
	tableHeader: {
		background: theme.palette.primary.main,
		color: theme.palette.common.white,
		width: '200px',
		position: 'sticky',
		borderBottom: 0,
		textAlign: 'center',
	},
	tableHeadeIcon: {
		width: '0.25em',
		background: theme.palette.primary.main,
		borderBottom: 0,
	},
	searchBar: {
		marginTop: 8,
	},
	tableRow: {
		height: '3em',
		backgroundColor: '#dcdcdc',
		'&:nth-of-type(odd)': {
			backgroundColor: theme.palette.common.white,
		},
	},
	tableCell: {
		//verticalAlign: 'top',
		//maxWidth: '4em',
		fontSize: '.9rem',
		borderColor: theme.palette.common.grey,
		overflow: 'hidden',
		padding: '0px 16px',
		borderWidth: '0px',
		borderRightWidth: '1px',
		borderBottomWidth: '1px',
		borderStyle: 'solid',
		'&:last-child': {
			borderRightWidth: '0px',
		},
	},
	nestedTableCell: {
		fontSize: '.9rem',
		backgroundColor: 'transparent',
		overflow: 'hidden',
		padding: '0px 16px',
		borderColor: theme.palette.secondary.main,
		borderWidth: '0px',
	},
	tableCellWithNestedTable: {
		padding: '0px',
		height: '100%',
		//backgroundColor: theme.palette.common.white,
		borderWidth: '0px',
		borderBottomWidth: '1px',
		borderBottomStyle: 'solid',
		borderBottomColor: theme.palette.common.grey,
	},
	historyTableCell: {
		backgroundColor: theme.palette.common.white,
		borderBottom: 0,
	},
	inactive: {
		borderRadius: '0',
		color: 'white',
		backgroundColor: theme.palette.common.grey,
		fontSize: '.7rem',
		borderBottom: 0,
		'&:nth-of-type(odd)': {
			backgroundColor: theme.palette.common.grey,
		},
	},
}));

export default useStyles;
